import { ErrorLabel, Label, Radio } from '@components';
import { useRecoilValue } from 'recoil';
import { RateCardFormErrors } from '@state';
import styles from './RateCard.module.scss';
import { ILane } from '@types';
import { useClearRCSettingsError, useIsInRoute, useRateCardState } from '@hooks';

type TRateCardCharacteristicsProps = {
	isDisabled?: boolean;
}
export const RateCardCharacteristics = (props: TRateCardCharacteristicsProps) => {
	const { isDisabled = false } = props;
	const carrierInRoute = useIsInRoute('carrier');
	const [rateCard, setRateCard] = useRateCardState();
	const rcFormErrors = useRecoilValue(RateCardFormErrors);
	const clearRCSettingsError = useClearRCSettingsError();

	const updateField = (name: string, value: string) => {
		const update = {
			...rateCard,
			[name]: value === 'yes'
		}
		clearRCSettingsError(`${name}._errors`)
		setRateCard(update as ILane);
	}

	const hasError = (key: string) => {
		// @ts-ignore
		return rcFormErrors?.[key]?._errors?.[0] || '';
	}

	if (!rateCard) return;
	return (
		<div className={carrierInRoute ? styles.row : ''}>
			<div>
				<Label required>Is this a contractual rate card?</Label>
				<Radio.Group className={styles.radioGroup}>
					<Radio
						name={'is_contracted'}
						label={'Yes'}
						value={'yes'}
						onChange={(e) => updateField('is_contracted', e.target.value)}
						checked={rateCard.is_contracted === true}
						keepErrorSpace={false}
						disabled={isDisabled}
					/>
					<Radio
						name={'is_contracted'}
						label={'No'}
						value={'no'}
						onChange={(e) => updateField('is_contracted', e.target.value)}
						checked={rateCard.is_contracted === false}
						keepErrorSpace={false}
						disabled={isDisabled}
					/>
				</Radio.Group>
				<ErrorLabel
					// noErrorNoContainer
					hasError={!!hasError('is_contracted')}
					errorMessage={hasError('is_contracted')}
				/>
			</div>
			<div>
				<Label required>Is this a 4PL rate card?</Label>
				<Radio.Group className={styles.radioGroup}>
					<Radio
						name={'is_4pl'}
						label={'Yes'}
						value={'yes'}
						onChange={(e) => updateField('is_4pl', e.target.value)}
						checked={rateCard.is_4pl === true}
						keepErrorSpace={false}
						disabled={isDisabled}
					/>
					<Radio
						name={'is_4pl'}
						label={'No'}
						value={'no'}
						onChange={(e) => updateField('is_4pl', e.target.value)}
						checked={rateCard.is_4pl === false}
						keepErrorSpace={false}
						disabled={isDisabled}
					/>
				</Radio.Group>
				<ErrorLabel
					// noErrorNoContainer
					hasError={!!hasError('is_4pl')}
					errorMessage={hasError('is_4pl')}
				/>

			</div>
		</div>
	);
}
